export default __webpack_public_path__ + "45a1a77ded1ddab6d4d10a3c88f1e952.png";